import React from 'react'

export function CalendarIcon() {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none">
      <g clipPath="url(#clip0)">
        <path d="M15.8906 1.90625H15.0469V0.5H13.6406V1.90625H4.35938V0.5H2.95312V1.90625H2.10938C0.946266 1.90625 0 2.85252 0 4.01562V16.3906C0 17.5537 0.946266 18.5 2.10938 18.5H15.8906C17.0537 18.5 18 17.5537 18 16.3906V4.01562C18 2.85252 17.0537 1.90625 15.8906 1.90625ZM16.5938 16.3906C16.5938 16.7783 16.2783 17.0938 15.8906 17.0938H2.10938C1.72167 17.0938 1.40625 16.7783 1.40625 16.3906V7.10938H16.5938V16.3906ZM16.5938 5.70312H1.40625V4.01562C1.40625 3.62792 1.72167 3.3125 2.10938 3.3125H2.95312V4.71875H4.35938V3.3125H13.6406V4.71875H15.0469V3.3125H15.8906C16.2783 3.3125 16.5938 3.62792 16.5938 4.01562V5.70312Z" fill="#484C67"/>
        <path d="M4.07812 8.58594H2.67188V9.99219H4.07812V8.58594Z" fill="#484C67"/>
        <path d="M6.89062 8.58594H5.48438V9.99219H6.89062V8.58594Z" fill="#484C67"/>
        <path d="M9.70312 8.58594H8.29688V9.99219H9.70312V8.58594Z" fill="#484C67"/>
        <path d="M12.5156 8.58594H11.1094V9.99219H12.5156V8.58594Z" fill="#484C67"/>
        <path d="M15.3281 8.58594H13.9219V9.99219H15.3281V8.58594Z" fill="#484C67"/>
        <path d="M4.07812 11.3984H2.67188V12.8047H4.07812V11.3984Z" fill="#484C67"/>
        <path d="M6.89062 11.3984H5.48438V12.8047H6.89062V11.3984Z" fill="#484C67"/>
        <path d="M9.70312 11.3984H8.29688V12.8047H9.70312V11.3984Z" fill="#484C67"/>
        <path d="M12.5156 11.3984H11.1094V12.8047H12.5156V11.3984Z" fill="#484C67"/>
        <path d="M4.07812 14.2109H2.67188V15.6172H4.07812V14.2109Z" fill="#484C67"/>
        <path d="M6.89062 14.2109H5.48438V15.6172H6.89062V14.2109Z" fill="#484C67"/>
        <path d="M9.70312 14.2109H8.29688V15.6172H9.70312V14.2109Z" fill="#484C67"/>
        <path d="M12.5156 14.2109H11.1094V15.6172H12.5156V14.2109Z" fill="#484C67"/>
        <path d="M15.3281 11.3984H13.9219V12.8047H15.3281V11.3984Z" fill="#484C67"/>
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="18" height="18" fill="white" transform="translate(0 0.5)"/>
        </clipPath>
      </defs>
    </svg>
  )
}